// The reservation preview over the page (ShoppingBag/Preview.vue, in the rental layout).
// "Mijn reservering" in the header and "Naar je reservering" on a product open it first.
export function useBagPreview () {
  const open = useState('bag-preview-open', () => false)
  return {
    open,
    show: () => { open.value = true },
    hide: () => { open.value = false }
  }
}
